var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import EventRunnerDefault from "./event_runners/EventRunnerDefault";
import EventRunnerNTimes from "./event_runners/EventRunnerNTimes";

var EventEmitter = function () {
  function EventEmitter() {
    this._events = Object.create(null);
  }

  EventEmitter.prototype.on = function (eventName, handler) {
    this._addEventListener(eventName, new EventRunnerDefault(this, handler));
  };

  EventEmitter.prototype.once = function (eventName, handler) {
    this._addEventListener(eventName, new EventRunnerNTimes(this, handler, 1));
  };

  EventEmitter.prototype.off = function (eventName, handler) {
    var events = this._events[eventName];

    if (!(events === null || events === void 0 ? void 0 : events.length)) {
      return;
    }

    this._events[eventName] = events.filter(function (h) {
      return h.getHandler() !== handler;
    });
  };

  EventEmitter.prototype.offByName = function (eventName) {
    var events = this._events[eventName];

    if (events === undefined) {
      return;
    }

    events.length = 0;
    delete this._events[eventName];
  };

  EventEmitter.prototype.offAll = function () {
    var _this = this;

    Object.keys(this._events).forEach(function (eventName) {
      var events = _this._events[eventName];

      if (events) {
        events.length = 0;
      }
    });
    this._events = Object.create(null);
  };

  EventEmitter.prototype.emit = function (eventName) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var events = this._events[eventName];

    if (events) {
      events.forEach(function (handler) {
        return handler.run.apply(handler, __spreadArrays([eventName], args));
      });
    }
  };

  EventEmitter.prototype.has = function (eventName, handler) {
    var events = this._events[eventName];

    if (!events) {
      return false;
    }

    for (var i = 0; i < events.length; i++) {
      if (events[i].getHandler() === handler) {
        return true;
      }
    }

    return false;
  };

  EventEmitter.prototype._addEventListener = function (eventName, runner) {
    var events = this._events[eventName];

    if (Array.isArray(events)) {
      events.push(runner);
    } else {
      this._events[eventName] = [runner];
    }
  };

  return EventEmitter;
}();

export { EventEmitter };